export default {"src":"/_next/static/media/emojiWhite.7ea9c235.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};